import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { useOrderHistoryWithDetails } from '@/data/Content/OrderHistory';
import {
	linkComprarSX,
	noOrdersSX,
	titleSectionSX,
} from '@/components/content/OrderHistory/parts/History/style/historyOrders';
import { Linkable } from '@/components/blocks/Linkable';
import { OrderCard } from '@/components/content/OrderHistory/parts/History/parts/OrderCard';
import { useIsMobile } from '@/data/hooks/useIsMobile';
import { UsePagination } from '@/components/blocks/UsePagination';
import { OrderCardSkeleton } from '@/components/content/OrderHistory/parts/History/parts/OrderCardSkeleton';
import Head from 'next/head';

const ELEMENTS_PER_PAGE = 9;

export const OrderHistory: React.FC = () => {
	const isMobile = useIsMobile();

	const [pageNumber, setPageNumber] = React.useState(1);

	const { ordersWithItemsDetails, onReOrder, orderRecordSetTotal, loading } =
		useOrderHistoryWithDetails({
			pageNumber,
			pageSize: ELEMENTS_PER_PAGE,
		});

	const totalPages = Math.ceil(orderRecordSetTotal / ELEMENTS_PER_PAGE);

	const handleChangePage = (_: React.ChangeEvent<unknown>, page: number) => {
		setPageNumber(page);
	};

	return (
		<Stack spacing={'20px'}>
			<Head>
				<title>{'Mis pedidos'}</title>
			</Head>

			<Typography component={'h1'} sx={titleSectionSX}>
				{'Historial de pedidos'}
			</Typography>
			{!loading && ordersWithItemsDetails.length === 0 ? (
				<Box sx={noOrdersSX}>
					<Typography>{'Parece que aún no has hecho un pedido'}</Typography>
					<Linkable href="/" sx={linkComprarSX}>
						{'Comprar ahora'}
					</Linkable>
				</Box>
			) : null}
			{loading ? (
				<React.Fragment>
					{Array.from({ length: ELEMENTS_PER_PAGE }).map((_, index) => (
						<OrderCardSkeleton key={index} />
					))}
				</React.Fragment>
			) : null}
			{!loading ? (
				<React.Fragment>
					{ordersWithItemsDetails.map((row) => (
						<OrderCard
							key={row.orderId}
							order={row}
							isMobile={isMobile}
							onReOrder={onReOrder(row.orderId ?? '-1')}
						/>
					))}
				</React.Fragment>
			) : null}
			<Box marginTop="20px">
				<UsePagination
					count={totalPages}
					page={pageNumber}
					onChange={handleChangePage}
					disabled={loading}
				/>
			</Box>
		</Stack>
	);
};
